import React from "react";
import Button from "@components/Button";
import "./style.scss";

export default function StickyButton({ children, additionalElement=false, ...props }) {
  return (
    <div className="sticky-button-wrapper full-width">
      <div className="inner">
        {additionalElement}
        <Button {...props}>{children}</Button>
      </div>
    </div>
  );
}
